import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {CodaltComponent} from '../codalt.component';
import {CodaltLogoComponent} from './codalt-logo/codalt-logo.component';
import {VACANCY_ADS, VacancyAd} from './vacancy-ads';

/**
 * Public, unlisted page showing a single square vacancy advertisement. Only reachable by its url.
 */
@Component({
    selector: 'app-vacancy-page',
    templateUrl: './vacancy-page.component.html',
    styleUrls: ['./vacancy-page.component.scss'],
    imports: [
        CodaltLogoComponent
    ]
})
export class VacancyPageComponent extends CodaltComponent implements OnInit {

    readonly ad = signal<VacancyAd | null>(null);

    constructor(private route: ActivatedRoute, private titleService: Title) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.route.paramMap.subscribe(params => {
                const ad = VACANCY_ADS.find(vacancy => vacancy.slug === params.get('slug')) ?? null;
                this.ad.set(ad);
                this.titleService.setTitle(ad ? `${ad.title.replace('\n', ' ')} | Werken bij Codalt` : 'Werken bij Codalt');
            })
        );
    }
}
